"use client";

import {
    createContext,
    useContext,
    useState,
    ReactNode
} from "react";


type ToastType =
    "success" |
    "error" |
    "warning" |
    "info";


type Toast = {
    id:number;
    type:ToastType;
    message:string;
};


const ToastContext = createContext<any>(null);


export function ToastProvider({
    children
}:{
    children:ReactNode;
}){


    const [toasts,setToasts] = useState<Toast[]>([]);



    function show(
        type:ToastType,
        message:string
    ){


        const id = Date.now();


        setToasts(prev=>[
            ...prev,
            {
                id,
                type,
                message
            }
        ]);


        setTimeout(()=>{

            setToasts(prev =>
                prev.filter(t=>t.id !== id)
            );

        },4000);


    }



    function remove(id:number){

        setToasts(prev =>
            prev.filter(t=>t.id !== id)
        );

    }



    return (

        <ToastContext.Provider
            value={{
                success:(m:string)=>show("success",m),
                error:(m:string)=>show("error",m),
                warning:(m:string)=>show("warning",m),
                info:(m:string)=>show("info",m),
            }}
        >

            {children}


            <div className="fixed bottom-5 left-5 z-50 space-y-3">


                {
                    toasts.map(t=>(

                        <div
                            key={t.id}
                            className={`
                            px-5 py-4 rounded-xl shadow-xl text-white min-w-[280px]
                            ${
                                t.type==="success"
                                ? "bg-green-600"
                                :
                                t.type==="error"
                                ? "bg-red-600"
                                :
                                t.type==="warning"
                                ? "bg-yellow-500"
                                :
                                "bg-blue-600"
                            }
                            `}
                        >

                            {t.message}


                            <button
                                className="ml-4"
                                onClick={()=>remove(t.id)}
                            >
                                ×
                            </button>


                        </div>

                    ))
                }


            </div>


        </ToastContext.Provider>

    );

}



export function useToast(){

    return useContext(ToastContext);

}
